<div
	class="tw-flex tw-gap-0.5 tw-border-b tw-items-center {{ typeClasses.borderRadiusClass }} {{ typeClasses.fontSizeClass }} {{
		typeClasses.fontWeightClass
	}}  {{ typeClasses.fontStyleClass }} {{ styleClasses.backgroundColorClass }} {{ styleClasses.fontColorClass }}"
	[style.padding]="paddingStyle"
	style="width: fit-content">
	<ng-content></ng-content>
</div>
